export default __webpack_public_path__ + "static/media/hardware.05e4b6a2.jpg";